
const platforms = {
  Quest: 'quest',
  Pico: 'pico',
  Vive: 'vive',
  IOS: 'ios',
  Android: 'android',
  Desktop: 'pc',
  Mac: 'mac',
  Streaming: 'web',
}

export default {
  ...platforms,
  All: Object.values(platforms),
}
